"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Slide.default;
  }
});

var _Slide = _interopRequireDefault(require("./Slide"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/Slide/index.js
// module id = 370
// module chunks = 0